import { defineMessages } from 'react-intl';

const translations = {
  fields: {
    name: {
      label: {
        id: 'properties.name',
        defaultMessage: 'Name',
        description: 'label of the name field',
      },
    },
    cocNumber: {
      label: {
        id: 'properties.cocNumber',
        defaultMessage: 'CoC number',
        description: 'label of the coc number field',
      },
    },
    spendingLimit: {
      label: {
        id: 'properties.spendingLimit',
        defaultMessage: 'Spending limit',
        description: 'label of spending limit field',
      },
    },
    currentDueAmount: {
      label: {
        id: 'properties.currentDueAmount',
        defaultMessage: 'Current due amount',
        description: 'label of the current due amount field',
      },
    },
    accountManager: {
      label: {
        id: 'properties.accountManager',
        defaultMessage: 'Account manager',
        description: 'label of the account manager field',
      },
      placeholder: {
        id: 'pages.organisationForm.accountManager.placeholder',
        defaultMessage: 'Search account manager',
        description: 'Placeholder of the account manager= search field in the organisation form',
      },
    },
    iban: {
      label: {
        id: 'properties.iban',
        defaultMessage: 'IBAN',
        description: 'label of the iban field',
      },
    },
    ibanNumber: {
      label: {
        id: 'properties.number',
        defaultMessage: 'Number',
        description: 'label of the iban number field',
      },
    },
    receiveInvoiceInEmail: {
      label: {
        id: 'properties.receiveInvoiceInEmail',
        defaultMessage: 'Receive invoice in email',
        description: 'label of the receive invoice in email field',
      },
    },
    receiveInvoiceInMail: {
      label: {
        id: 'properties.receiveInvoiceInMail',
        defaultMessage: 'Receive invoice in mail',
        description: 'label of the receive invoice in mail field',
      },
    },
    receiveInvoiceAtDelivery: {
      label: {
        id: 'properties.receiveInvoiceAtDelivery',
        defaultMessage: 'Receive invoice at delivery',
        description: 'label of the receive invoice at delivery field',
      },
    },
    administrationEmail: {
      label: {
        id: 'properties.administrationEmail',
        defaultMessage: 'Invoicing email address',
        description: 'label of the administration email field',
      },
    },
    paymentTerm: {
      label: {
        id: 'properties.paymentTerm',
        defaultMessage: 'Payment term in days',
        description: 'label of the payment term field',
      },
    },
    isPrimary: {
      id: 'properties.isPrimary',
      defaultMessage: 'Primary',
      description: 'label of the is primary field',
    },
    primaryAddress: {
      label: {
        id: 'properties.primaryAddress',
        defaultMessage: 'Primary address',
        description: 'label of the primary address field',
      },
    },
    primaryPhoneNumber: {
      label: {
        id: 'properties.primaryPhoneNumber',
        defaultMessage: 'Primary phone number',
        description: 'label of the primary phone number field',
      },
    },
    registrations: {
      label: {
        id: 'properties.registrations',
        defaultMessage: 'Registrations',
        description: 'label of the registrations field',
      },
    },
    tags: {
      label: {
        id: 'properties.tags',
        defaultMessage: 'Tags',
        description: 'label of the tags field',
      },
    },
    logo: {
      label: {
        id: 'properties.logo',
        defaultMessage: 'Logo',
        description: 'label of the logo field',
      },
    },
  },
  paymentConditionOptions: {
    afterwards: {
      id: 'properties.afterwards',
      defaultMessage: 'Afterwards',
      description: 'label of the payment condition option afterwards',
    },
    inAdvance: {
      id: 'properties.inAdvance',
      defaultMessage: 'In advance',
      description: 'label of the payment condition option in advance',
    },
  },
};

export default defineMessages(translations);
